import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ToggleFooterModal } from '../../../actions/utils';
import { ISOCurrencyCovert } from '../../../helpers/locationHelper';
import { PostIntinerariesAccomodation } from '../../../actions/itineraries';


class PriceSummary extends PureComponent {

  constructor(props){
    super(props);
    this.onBookClicked = this.onBookClicked.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  onBookClicked(){

    const { type, itineraries, openModal, PostIntinerariesAccomodation } = this.props;

    if(type === 'itinerary'){
      openModal();
    }
    if(type === 'payment' && itineraries.total_paid === "0.00"){
      PostIntinerariesAccomodation(itineraries).then(() => {
        window.location.href = `${process.env.REACT_APP_WWW_BOOKING_URL}/paymentdetails/${itineraries.tms_group_booking_id}/cyoa`;
      });
    }

  }

  openModal(e){
    e.preventDefault();
    this.props.ToggleFooterModal(e.target.href, true);
  }

  render(){

    const { itineraries:{content:{nr_pax, nr_days, nr_cities}, total_paid, iso_currency, grand_total}, isUpdating, buttononly } = this.props;

    if(buttononly){
      return (
        <div className="cyoa-pricing-summary-button">
        <button
          type="button"
          className={`busabout--cta orange book-button ${total_paid === "0.00" ? "" : "confirmed" }`}
          onClick={this.onBookClicked}
          disabled={ (isUpdating) ? true : false}>
          <span style={{display:isUpdating ? "none" : "block"}}>
            <span style={{display: total_paid === "0.00" ? 'block' : "none"}}>Book now</span>
            <span style={{display: total_paid !== "0.00" ? 'block' : "none"}}>Booking confirmed</span>
          </span>
          <span style={{display:isUpdating ? "block" : "none"}}><span className="fa fa-spinner fa-lg fa-spin"></span></span>
        </button>
        </div>
      )
    }
    else{
        return (
          <div className="cyoa-pricing-summary">
            <div className="row">
              <div className="column small-12 large-11 large-offset-0-5">
                <div className="row">
                  <div className="column small-12">

                    <h5 className="busabout-h5 no-margin">{total_paid === "0.00" ? "Total price" : "Balance due"}</h5>
                    <p className={`price-text orange-text ${total_paid === "0.00" ? "" : "confirmed" }`}>
                      {ISOCurrencyCovert(iso_currency)}{parseFloat(grand_total).toFixed(2)}&nbsp;
                      <span className="currency">{iso_currency}</span>
                    </p>

                    <ul>

                    <li>
                    <svg xmlns="http://www.w3.org/2000/svg" width="75.315" height="67.558" viewBox="0 0 75 67" className="traveller-svg">
                      <g data-name="Layer 2">
                        <g data-name="Layer 1">
                          <path d="M31.07 57.426H2.072a2 2 0 0 1-1.955-1.577c-.578-2.672 1.02-6.933 3.979-10.6 2.901-3.598 9.582-9.632 21.72-9.632a31.363 31.363 0 0 1 9.636 1.447 2 2 0 0 1-1.228 3.807 27.362 27.362 0 0 0-8.408-1.254c-10.474 0-16.154 5.101-18.607 8.142a15.556 15.556 0 0 0-3.026 5.666H31.07a2 2 0 0 1 0 4z"/>
                          <path d="M25.816 39.617a19.809 19.809 0 1 1 18.665-26.455 2 2 0 0 1-3.767 1.342 15.81 15.81 0 1 0-14.898 21.113 15.67 15.67 0 0 0 6.739-1.503 2 2 0 0 1 1.707 3.618 19.637 19.637 0 0 1-8.446 1.885zM61.666 67.558H26.44a2 2 0 0 1-1.955-1.578c-.578-2.672 1.02-6.932 3.979-10.6 2.902-3.597 9.582-9.632 21.721-9.632 10.383 0 16.776 4.37 20.311 8.034a2 2 0 0 1-2.879 2.778c-2.997-3.107-8.454-6.811-17.432-6.811-10.475 0-16.155 5.103-18.608 8.144a15.546 15.546 0 0 0-3.026 5.665h33.115a2 2 0 0 1 0 4z"/>
                          <path d="M50.185 49.749A19.809 19.809 0 1 1 69.993 29.94a19.83 19.83 0 0 1-19.807 19.809zm0-35.617A15.809 15.809 0 1 0 65.993 29.94a15.827 15.827 0 0 0-15.807-15.808z"/>
                          <path d="M50.084 41.723a10.12 10.12 0 0 1-9.595-6.934 2 2 0 1 1 3.793-1.27 6.107 6.107 0 0 0 11.755-.536 2 2 0 1 1 3.895.91 10.208 10.208 0 0 1-9.848 7.83zM73.315 67.558h-5.322a2 2 0 1 1 0-4h3.322V60.18a2 2 0 0 1 4 0v5.378a2 2 0 0 1-2 2zM25.201 31.59a10.116 10.116 0 0 1-9.594-6.935 2 2 0 0 1 3.793-1.267 6.124 6.124 0 0 0 5.8 4.203 6.582 6.582 0 0 0 6.386-4.45 2 2 0 1 1 3.865 1.03 10.541 10.541 0 0 1-10.25 7.42zM31.07 57.426H2.072a2 2 0 0 1-1.955-1.577c-.578-2.672 1.02-6.933 3.979-10.6 2.901-3.598 9.582-9.632 21.72-9.632a31.363 31.363 0 0 1 9.636 1.447 2 2 0 0 1-1.228 3.807 27.362 27.362 0 0 0-8.408-1.254c-10.474 0-16.154 5.101-18.607 8.142a15.556 15.556 0 0 0-3.026 5.666H31.07a2 2 0 0 1 0 4z"/>
                          <path d="M25.816 39.617a19.809 19.809 0 1 1 18.665-26.455 2 2 0 0 1-3.767 1.342 15.81 15.81 0 1 0-14.898 21.113 15.67 15.67 0 0 0 6.739-1.503 2 2 0 0 1 1.707 3.618 19.637 19.637 0 0 1-8.446 1.885zM61.666 67.558H26.44a2 2 0 0 1-1.955-1.578c-.578-2.672 1.02-6.932 3.979-10.6 2.902-3.597 9.582-9.632 21.721-9.632 10.383 0 16.776 4.37 20.311 8.034a2 2 0 0 1-2.879 2.778c-2.997-3.107-8.454-6.811-17.432-6.811-10.475 0-16.155 5.103-18.608 8.144a15.546 15.546 0 0 0-3.026 5.665h33.115a2 2 0 0 1 0 4z"/>
                          <path d="M50.185 49.749A19.809 19.809 0 1 1 69.993 29.94a19.83 19.83 0 0 1-19.807 19.809zm0-35.617A15.809 15.809 0 1 0 65.993 29.94a15.827 15.827 0 0 0-15.807-15.808z"/>
                          <path d="M50.084 41.723a10.12 10.12 0 0 1-9.595-6.934 2 2 0 1 1 3.793-1.27 6.107 6.107 0 0 0 11.755-.536 2 2 0 1 1 3.895.91 10.208 10.208 0 0 1-9.848 7.83zM73.315 67.558h-5.322a2 2 0 1 1 0-4h3.322V60.18a2 2 0 0 1 4 0v5.378a2 2 0 0 1-2 2zM25.201 31.59a10.116 10.116 0 0 1-9.594-6.935 2 2 0 0 1 3.793-1.267 6.124 6.124 0 0 0 5.8 4.203 6.582 6.582 0 0 0 6.386-4.45 2 2 0 1 1 3.865 1.03 10.541 10.541 0 0 1-10.25 7.42z"/>
                        </g>
                      </g>
                    </svg>
                      x {nr_pax}
                    </li>

                      <li>
                      <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" className="days-svg">
                        <g fill="none" fillRule="evenodd">
                          <path d="M11.7 10.4H9.85a.52.52 0 0 1-.52-.52V8.02a.52.52 0 0 1 1.04 0v1.34h1.35a.52.52 0 1 1 0 1.04" fill="#F60"/>
                          <g transform="translate(0 -.24)">
                            <path d="M9.85 1.33a8.81 8.81 0 0 0-8.81 8.8 8.81 8.81 0 0 0 17.63 0c0-4.86-3.96-8.8-8.82-8.8m0 18.62A9.85 9.85 0 0 1 0 10.12a9.85 9.85 0 0 1 19.7 0 9.85 9.85 0 0 1-9.85 9.83" fill="#F60" mask="url(#b)"/>
                          </g>
                          <path d="M9.85 2.95A6.95 6.95 0 0 0 2.9 9.88a6.95 6.95 0 0 0 13.9 0 6.95 6.95 0 0 0-6.95-6.93m0 14.9a7.98 7.98 0 0 1-7.98-7.97 7.98 7.98 0 0 1 15.97 0c0 4.39-3.58 7.96-7.99 7.96" fill="#F60"/>
                          <path d="M9.72 4.83a.52.52 0 0 1-.52-.51V2.46a.52.52 0 0 1 1.04 0v1.86c0 .28-.24.51-.52.51M4.28 10.26H2.4a.52.52 0 1 1 0-1.03h1.87a.52.52 0 1 1 0 1.03M9.72 17.55a.52.52 0 0 1-.52-.52v-1.86a.52.52 0 0 1 1.04 0v1.86c0 .29-.24.52-.52.52M17.02 10.26h-1.86a.52.52 0 1 1 0-1.03h1.86a.52.52 0 1 1 0 1.03" fill="#F60"/>
                        </g>
                      </svg>
                        {nr_days + 1} days
                      </li>

                      <li>

                      <svg width="17" height="21" viewBox="0 0 17 21" xmlns="http://www.w3.org/2000/svg" className="city-svg">
                        <g fill="none" fillRule="evenodd">
                          <path d="M8.34 3.97a3.46 3.46 0 1 0 0 6.92 3.46 3.46 0 0 0 0-6.92m0 8.02a4.57 4.57 0 1 1 0-9.13 4.57 4.57 0 0 1 0 9.13" fill="#F60"/>
                          <path d="M8.34 5.98a1.45 1.45 0 1 0 0 2.9 1.45 1.45 0 0 0 0-2.9m0 4a2.56 2.56 0 1 1 0-5.12 2.56 2.56 0 0 1 0 5.12" fill="#F60"/>
                          <g>
                            <path d="M11.24 18a.55.55 0 0 1-.45-.88c1.03-1.42 3.8-5.37 4.25-6.54.35-.9.53-1.69.53-2.35a7.2 7.2 0 0 0-2.11-5.28A6.85 6.85 0 0 0 8.31 1.1a6.84 6.84 0 0 0-5.1 1.84 7.19 7.19 0 0 0-2.1 5.28c0 .57.12 1.23.38 1.97.43 1.25 3.55 5.4 4.7 6.9a.55.55 0 0 1-.86.68C4.89 17.2 1 12.2.44 10.56A7.28 7.28 0 0 1 0 8.23c0-2.41.87-4.57 2.45-6.08A7.94 7.94 0 0 1 8.34 0c2.25-.1 4.34.66 5.88 2.14a8.28 8.28 0 0 1 2.45 6.08c0 .8-.2 1.73-.6 2.75-.6 1.54-4.23 6.57-4.38 6.78a.55.55 0 0 1-.45.23" fill="#F60" mask="url(#b)"/>
                          </g>
                          <g transform="translate(6 18)">
                            <path d="M2.34 3a.55.55 0 0 1-.4-.16L.71 1.6A.55.55 0 1 1 1.5.83l.84.84.84-.84a.55.55 0 1 1 .78.78L2.73 2.84c-.11.1-.25.16-.4.16" fill="#F60" mask="url(#d)"/>
                          </g>
                        </g>
                      </svg>
                        {nr_cities} Cities</li>
                    </ul>

                    <button
                      type="button"
                      className={`busabout--cta orange book-button ${total_paid === "0.00" ? "" : "confirmed" }`}
                      onClick={this.onBookClicked}
                      disabled={ (isUpdating) ? true : false}>
                      <span style={{display:isUpdating ? "none" : "block"}}>
                        <span style={{display: total_paid === "0.00" ? 'block' : "none"}}>Book now</span>
                        <span style={{display: total_paid !== "0.00" ? 'block' : "none"}}>Booking confirmed</span>
                      </span>
                      <span style={{display:isUpdating ? "block" : "none"}}><span className="fa fa-spinner fa-lg fa-spin"></span></span>
                    </button>

                    <p className="no-margin">For further information read our <a href="https://www.busabout.com/privacy-policy?SQ_DESIGN_NAME=simple" target="_blank" className="busabout--cta--link orange bold" rel="noopener noreferrer" onClick={e => this.openModal(e) }>FAQ </a>
                      and for booking policy, see our <a href="https://www.busabout.com/terms-conditions?SQ_DESIGN_NAME=simple" target="_blank" className="busabout--cta--link orange bold" rel="noopener noreferrer" onClick={e => this.openModal(e) }> terms and conditions</a></p>

                      <a className="live-button margin-t-40" href="https://m.me/Busabout?ref=w3418156" target="_blank"  rel="noopener noreferrer" title="Chat with one of our expert travel advisers.">

                          <svg xmlns="http://www.w3.org/2000/svg" width="72.542" height="57.0645" viewBox="0 0 72.542 57.0645"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M39.74,35.7H14.8057a2,2,0,0,1,0-4H39.74a5.9607,5.9607,0,0,0,5.9541-5.9541V9.9531A5.9605,5.9605,0,0,0,39.74,4H9.9531A5.96,5.96,0,0,0,4,9.9531v13.792a2,2,0,0,1-4,0V9.9531A9.9643,9.9643,0,0,1,9.9531,0H39.74a9.9651,9.9651,0,0,1,9.9541,9.9531v15.793A9.9659,9.9659,0,0,1,39.74,35.7Z"/><path d="M36.5938,16.001H13.1006a2,2,0,1,1,0-4H36.5938a2,2,0,0,1,0,4Z"/><path d="M31.0107,23.6992H18.6836a2,2,0,0,1,0-4H31.0107a2,2,0,1,1,0,4Z"/><path d="M10.0127,39.707H2a2,2,0,0,1-2-2V29.6934a2,2,0,0,1,4,0V35.707h6.0127a2,2,0,0,1,0,4Z"/><path d="M57.7354,53.0586H32.8008a9.9659,9.9659,0,0,1-9.9541-9.9541V33.7021a2,2,0,1,1,4,0v9.4023a5.9607,5.9607,0,0,0,5.9541,5.9541H57.7354a2,2,0,0,1,0,4Z"/><path d="M70.542,43.1035a2,2,0,0,1-2-2V27.3115a5.9605,5.9605,0,0,0-5.9541-5.9531H47.6943a2,2,0,0,1,0-4H62.5879a9.9651,9.9651,0,0,1,9.9541,9.9531v13.792A2,2,0,0,1,70.542,43.1035Z"/><path d="M59.44,33.3584H45.375a2,2,0,1,1,0-4H59.44a2,2,0,0,1,0,4Z"/><path d="M53.8584,41.0576H41.53a2,2,0,0,1,0-4H53.8584a2,2,0,0,1,0,4Z"/><path d="M70.542,57.0645H62.5283a2,2,0,0,1,0-4H68.542V47.0518a2,2,0,0,1,4,0v8.0127A2,2,0,0,1,70.542,57.0645Z"/></g></g></svg>

                          Live Chat Now
                      </a>

                  </div>
                </div>

              </div>
            </div>
          </div>
        )
      }
  }
}

function mapStateToProps(state){
  return {
    itineraries:state.itineraries.data,
    isUpdating:state.bookingGroup.updating,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    ToggleFooterModal,
    PostIntinerariesAccomodation
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PriceSummary);



// WEBPACK FOOTER //
// ./src/components/itinerary/components/price-summary.js